var $menu = $(".vg-categories-main ul, .vg-category-sidebar ul");
var categoryProductTimeout;

$menu.menuAim({
	activate: activateSubmenu,
	deactivate: deactivateSubmenu,
	exitMenu: function() {
		$menu.find('.sub-menu').removeClass("active");
		$menu.find('.sub-menu').removeClass("active");
		return true;
	}
});

function activateSubmenu(row) {
	var $row = $(row),
		submenuId = $row.data("submenuId"),
		$submenu = $("#" + submenuId),
		height = $menu.outerHeight(),
		width = $menu.outerWidth();

		var $idSub = document.getElementById(submenuId);

	if ($submenu.length) {
		$submenu.css('left', width);

		if ($menu.hasClass('home')) {
			var half_height = height / 2;
			var menu_offset = $menu.offset();
			var row_offset = $row.offset();
			var row_position_home = row_offset.top - menu_offset.top;

			if(half_height > row_position_home) {
				$submenu.css('top', 0);
			} else {
				$submenu.css('bottom', 0);
			}
		} else {
			var win_height = window.innerHeight;
			var offset_win = win_height - win_height/3;
			var position = $idSub.getBoundingClientRect().top;

			if(position < offset_win) {
				$submenu.css('top', 0);
			} else {
				$submenu.css('bottom', 0);
			}
		}

		$submenu.addClass('active');

		/*var categoryId = submenuId;

		 clearTimeout(categoryProductTimeout);
		 (function(categoryId) {
		 categoryProductTimeout = setTimeout(function(){
		 $cont = $('.categories-main .randomGoods');
		 var t = '';
		 for(var i = 0; i < 4; i++) {
		 t += '<div class="col-md-6 mb-1"><div class="loader"></div></div>';
		 }
		 $cont.html('<div class="spinners">'+t+'</div>');

		 var data = {category_id: categoryId};
		 $.get('/catalog/sidebar_products', data, function (data) {
		 $cont.find('.items').remove();
		 $cont.append('<div class="items" style="display: none;">'+data.view+'</div>');
		 $cont.find('.spinners').hide();
		 $cont.find('.items').fadeIn();
		 });
		 }, 300);
		 })(categoryId)
		 */
	}
}

function deactivateSubmenu(row) {
	var $row = $(row),
		submenuId = $row.data("submenuId"),
		$submenu = $("#" + submenuId);

	$submenu.removeClass("active");
}
